import type React from "react";
import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

// Register GSAP plugins globally
if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
}

export function GsapProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Ensure plugins are registered on mount
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
  }, []);

  return <>{children}</>;
}
